<button
    class="btn switch"
    [class.active]="isActive"
    (click)="toggleActiveHandler($event)"
    [disabled]="disabled"
></button>
